import { render, staticRenderFns } from "./Modal.Folder.Action.Create.vue?vue&type=template&id=48742f67&scoped=true&"
import script from "./Modal.Folder.Action.Create.vue?vue&type=script&lang=js&"
export * from "./Modal.Folder.Action.Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48742f67",
  null
  
)

export default component.exports